import { LegalEntityState } from '@mkp/shared/models';
import {
  CommercialRegisterEntry,
  LegalEntity,
  LegalEntityExternalSource,
  OrganisationEntry,
} from '@mkp/legal-entity/models';

export const isLegalEntityState = (value: unknown): value is LegalEntityState =>
  Object.values(LegalEntityState).includes(value as LegalEntityState);

export const isLegalEntityExternalSource = (value: unknown): value is LegalEntityExternalSource =>
  Object.values(LegalEntityExternalSource).includes(value as LegalEntityExternalSource);

export const isActiveLegalEntity = (legalEntity: LegalEntity): boolean =>
  legalEntity.state === LegalEntityState.Active;

export type LegalEntityUpdatePayload = Pick<LegalEntity, 'id' | 'state' | '_version'>;

export const isCommercialRegisterEntry = (value: unknown): value is CommercialRegisterEntry =>
  (value as CommercialRegisterEntry)._type === 'commercialRegisterEntry';

export const isOrganisationEntry = (value: unknown): value is OrganisationEntry =>
  (value as OrganisationEntry)._type === 'organisationEntry';

export const externalSourceToTranslationKey: Record<LegalEntityExternalSource, string> = {
  [LegalEntityExternalSource.ChCommercialRegisterEntry]:
    'LEGAL_ENTITY_DETAILS_PAGE.EXTERNAL_SOURCE.MONEYHOUSE',
  [LegalEntityExternalSource.ChUidRegisterEntry]: 'LEGAL_ENTITY_DETAILS_PAGE.EXTERNAL_SOURCE.UID',
  [LegalEntityExternalSource.Manual]: 'LEGAL_ENTITY_DETAILS_PAGE.EXTERNAL_SOURCE.MANUAL',
  [LegalEntityExternalSource.Network]: 'LEGAL_ENTITY_DETAILS_PAGE.EXTERNAL_SOURCE.NETWORK',
};
